export const LOGO = {
    image: '/assets/images/logo.png'
};